import { HubsSettingClient } from 'frontend-preferences-client';
import { fromHttpPromise } from 'pulse/adapters';
import { batchScheduler } from 'batch-promise';
const hubsSettingClient = HubsSettingClient.forCaller('hs-resources');
const scheduler = batchScheduler().read().identity(({
  settingName
}) => settingName).partition(() => 'hubSettings').execute(calls => {
  const callsArray = Object.values(calls);
  const httpClient = callsArray[0].httpClient;
  const defaults = {};
  for (const call of callsArray) {
    defaults[call.settingName] = '';
  }
  return hubsSettingClient.withHttpClient(httpClient).batchFetch(defaults);
}).extract(({
  response,
  input
}) => {
  var _response$input$setti;
  return (_response$input$setti = response[input.settingName]) !== null && _response$input$setti !== void 0 ? _response$input$setti : '';
}).immediate();
const fetchHubSetting = (httpClient, params) => scheduler.queue(Object.assign({
  httpClient
}, params));
export const defaultHubSettingResolver = fromHttpPromise('hubSettingResolver', fetchHubSetting);
export const __TEST_ONLY_flushHubSettingScheduler = () => scheduler.flush();